import { useAppState } from 'store/hooks'
import {
  getLandingState,
  isLoading,
  getLandingSettings,
  getFeaturedProducts,
} from './selectors'

export const useLandingState = () => getLandingState(useAppState())

export const useLandingLoading = () => isLoading(useAppState())

export const useLandingSettings = () => getLandingSettings(useAppState())

export const useFeaturedProducts = () => getFeaturedProducts(useAppState())
